import { useInfiniteQuery } from '@tanstack/react-query';
import { FancyShareApi } from 'api/ApiHelper';
import { fancyShareQueryKey } from 'queries/fancyShare/queryKey';
import { FancySharesResponseDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';

const DEFAULT_LIMIT = 5;

const getNextPageParam = (lastGroup: FancySharesResponseDto, allGroups: FancySharesResponseDto[]) => {
  if ((lastGroup.fancyShares?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.fancyShares.length, 0);
};

export const useGetProfileFancySharesInfiniteQuery = (profileId: number, includeAdult: boolean) =>
  useInfiniteQuery({
    queryKey: fancyShareQueryKey.fancyShareProfileRoot(profileId, includeAdult),
    queryFn: ({ pageParam = 0 }) =>
      FancyShareApi.findByProfileId(profileId, includeAdult, { offset: pageParam, limit: DEFAULT_LIMIT }),
    initialPageParam: 0,
    getNextPageParam,
  });
